/**
 * Quanto falta na trilha.
 *
 * O denominador é o que está VISÍVEL agora, e isso vem contado do servidor: pergunta escondida
 * por condicional no denominador travaria a barra em 60% para quem respondeu tudo o que lhe
 * cabia — e uma barra que não fecha é a que faz a pessoa procurar o campo que não existe.
 */

import type { ProgressoDaTrilha } from "../../nucleo/kickoff";

export interface PropsDaBarra {
  progresso: ProgressoDaTrilha;
  /** Some com a frase de baixo quando o cartão já diz a mesma coisa em outro lugar. */
  compacta?: boolean;
}

export function BarraDeProgresso({ progresso, compacta = false }: PropsDaBarra) {
  const faltam = progresso.obrigatorias_visiveis - progresso.obrigatorias_respondidas;

  return (
    <div className="progresso" data-testid="progresso">
      <div
        className="progresso__trilho"
        role="progressbar"
        aria-valuenow={progresso.percentual}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Progresso do preenchimento"
      >
        <div className="progresso__barra" style={{ width: `${progresso.percentual}%` }} />
      </div>
      <p className="progresso__legenda">
        <span className="numero-tabular" data-testid="progresso-percentual">
          {progresso.percentual}%
        </span>{" "}
        · {progresso.respondidas} de {progresso.perguntas_visiveis} respondidas
        {compacta ? null : (
          <>
            {" "}
            ·{" "}
            {faltam > 0
              ? `${faltam} obrigatória${faltam > 1 ? "s" : ""} ainda sem resposta`
              : "nenhuma obrigatória pendente"}
          </>
        )}
      </p>
    </div>
  );
}
